export const BRAND = {
  name: process.env.REACT_APP_BRAND_NAME || 'Domain Kings',
  mark: process.env.REACT_APP_BRAND_MARK || '👑',
  domain: process.env.REACT_APP_BRAND_DOMAIN || 'domainkings.store',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'domains@leadideal.com',
  legal: {
    // LeadIdeal registered as Osek Patur in Israel
    companyName: process.env.REACT_APP_LEGAL_COMPANY_NAME || 'LeadIdeal (Osek Patur)',
    companyId: process.env.REACT_APP_LEGAL_COMPANY_ID || '314396169',
    registeredAddress: process.env.REACT_APP_LEGAL_ADDRESS || 'Hefziba 8, Haifa, Israel',
    address: process.env.REACT_APP_LEGAL_ADDRESS || 'Hefziba 8, Haifa, Israel',
    mailingAddress: '23600 Mercantile Rd, Suite C-100, Beachwood, OH 44122',
    phone: process.env.REACT_APP_LEGAL_PHONE || '+1 (219) 370-1517',
    whatsapp: 'https://wa.me/972503487788',
    contactEmail: process.env.REACT_APP_LEGAL_CONTACT_EMAIL || 'domains@leadideal.com',
    lastUpdated: process.env.REACT_APP_LEGAL_LAST_UPDATED || '2026-02-20',
  },
};

